import { render, staticRenderFns } from "./proTower.vue?vue&type=template&id=62521c3d&scoped=true&"
import script from "./proTower.vue?vue&type=script&lang=js&"
export * from "./proTower.vue?vue&type=script&lang=js&"
import style0 from "./proTower.vue?vue&type=style&index=0&id=62521c3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62521c3d",
  null
  
)

export default component.exports